var _style, _path, _rect, _rect2, _rect3, _rect4, _circle, _circle2, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _rect5, _rect6, _path2, _line, _line2, _path3, _path4, _g, _path5, _ellipse, _polygon7, _polygon8, _polygon9, _path6, _polygon0, _polygon1, _path7, _polygon10, _polygon11, _polygon12, _path8, _polygon13, _polygon14, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _polygon15, _polygon16, _polygon17, _path15, _polygon18, _polygon19, _path16, _polygon20, _polygon21, _polygon22, _path17, _polygon23, _polygon24, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _line3, _line4, _line5, _line6, _line7, _g2, _path26, _line8, _path27, _path28, _path29, _path30, _path31, _path32, _circle3, _ellipse2, _circle4, _ellipse3, _ellipse4, _ellipse5, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _line9, _path54, _path55, _path56, _rect7, _rect8, _rect9, _rect0, _circle5, _circle6, _polygon25, _polygon26, _polygon27, _polygon28, _polygon29, _polygon30, _rect1, _rect10, _path57, _rect11, _rect12, _rect13, _rect14, _circle7, _circle8, _polygon31, _polygon32, _polygon33, _polygon34, _polygon35, _polygon36, _rect15, _rect16, _path58, _rect17, _rect18, _rect19, _rect20, _circle9, _circle0, _polygon37, _polygon38, _polygon39, _polygon40, _polygon41, _polygon42, _rect21, _rect22, _path59, _ellipse6, _path60, _path61, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _ellipse7, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _ellipse8, _circle43, _circle44, _circle45, _circle46, _path62;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgJourneyBoat = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "boatMove",
  x: "0px",
  y: "0px",
  viewBox: "0 0 438 319.6",
  style: {
    enableBackground: "new 0 0 438 319.6"
  },
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.boatst0{fill:#49272A;stroke:url(#SVGIDBOAT_1_);stroke-width:0.5;stroke-miterlimit:10;}\r\n\t.boatst1{fill:#C56E29;}\r\n\t.boatst2{fill:#49272A;stroke:#F7B01A;stroke-width:0.5;stroke-miterlimit:10;}\r\n\t.boatst3{fill:#220D0F;stroke:#F7B01A;stroke-width:0.25;stroke-miterlimit:10;}\r\n\t.boatst4{fill:#49272A;}\r\n\t.boatst5{fill:#361D10;}\r\n\t.boatst6{fill:none;stroke:#2D231F;stroke-width:0.5;stroke-miterlimit:10;}\r\n\t.boatst7{fill:url(#SVGIDBOAT_2_);}\r\n\t.boatst8{fill:#A44F24;}\r\n\t.boatst9{fill:#224051;}\r\n\t.boatst10{fill:#37525C;}\r\n\t.boatst11{fill:url(#SVGIDBOAT_3_);}\r\n\t.boatst12{fill:#C48357;}\r\n\t.boatst13{fill:#6D9399;}\r\n\t.boatst14{fill:#607D80;}\r\n\t.boatst15{fill:#516768;}\r\n\t.boatst16{fill:#465656;}\r\n\t.boatst17{fill:#587272;}\r\n\t.boatst18{fill:#506363;}\r\n\t.boatst19{fill:#435D5F;}\r\n\t.boatst20{fill:#445554;}\r\n\t.boatst21{fill:#40504F;}\r\n\t.boatst22{fill:#3A4847;}\r\n\t.boatst23{fill:#384B4C;}\r\n\t.boatst24{fill:#364849;}\r\n\t.boatst25{fill:#283838;}\r\n\t.boatst26{fill:none;stroke:#2D231F;stroke-width:0.75;stroke-miterlimit:10;}\r\n\t.boatst27{fill:#2D231F;stroke:#2D231F;stroke-width:0.5;stroke-miterlimit:10;}\r\n\t.boatst28{fill:none;stroke:#152021;stroke-miterlimit:10;}\r\n\t.boatst29{fill:#5BBBD1;}\r\n\t.boatst30{fill:#0D1A23;}\r\n\t.boatst31{fill:none;stroke:#0D1A23;stroke-miterlimit:10;}\r\n\t.boatst32{fill:#593211;}\r\n\t.boatst33{fill:#331B0E;}\r\n\t.boatst34{fill:#B94426;}\r\n\t.boatst35{fill:#6FCCDD;stroke:#AD7D2C;stroke-width:0.5;stroke-miterlimit:10;}\r\n\t.boatst36{fill:#FEFFFF;}\r\n\t.boatst37{fill:#321B10;}\r\n\t.boatst38{fill:url(#SVGIDBOAT_4_);}\r\n\t.boatst39{fill:url(#SVGIDBOAT_5_);}\r\n\t.boatst40{fill:#090707;}\r\n\t.boatst41{fill:#2A4F60;}\r\n\t.boatst42{fill:#46737F;}\r\n\t.boatst43{fill:#757473;}\r\n\t.boatst44{fill:#49272A;stroke:url(#SVGIDBOAT_6_);stroke-width:0.5;stroke-miterlimit:10;}\r\n\t.boatst45{fill:#49272A;stroke:url(#SVGIDBOAT_7_);stroke-width:0.5;stroke-miterlimit:10;}\r\n\t.boatst46{fill:#49272A;stroke:url(#SVGIDBOAT_8_);stroke-width:0.5;stroke-miterlimit:10;}\r\n\t.boatst47{fill:none;stroke:#341618;stroke-width:0.75;stroke-miterlimit:10;}\r\n\t.boatst48{fill:url(#SVGIDBOAT_9_);}\r\n\t.boatst49{fill:url(#SVGIDBOAT_10_);}\r\n\t.boatst50{fill:url(#SVGIDBOAT_11_);}\r\n\t.boatst51{fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("g", {
  className: "gearsSpinner"
}, /*#__PURE__*/React.createElement("radialGradient", {
  id: "SVGIDBOAT_1_",
  cx: 142.8516,
  cy: 275.0736,
  r: 19.8062,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#C56E29"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6081,
  style: {
    stopColor: "#C56E29"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7886,
  style: {
    stopColor: "#C66F29"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8563,
  style: {
    stopColor: "#CA7528"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9051,
  style: {
    stopColor: "#D17E27"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9447,
  style: {
    stopColor: "#DA8B25"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9784,
  style: {
    stopColor: "#E89D20"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#F7B01A"
  }
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "boatst0",
  d: "M142.9,255.5c-10.8,0-19.6,8.8-19.6,19.6s8.8,19.6,19.6,19.6s19.6-8.8,19.6-19.6S153.7,255.5,142.9,255.5z  M142.9,290.3c-8.4,0-15.2-6.8-15.2-15.2s6.8-15.2,15.2-15.2s15.2,6.8,15.2,15.2S151.3,290.3,142.9,290.3z"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 127.6,
  y: 273.4,
  className: "boatst1",
  width: 30.2,
  height: 3.8
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 127.6,
  y: 273.4,
  transform: "matrix(6.123234e-17 -1 1 6.123234e-17 -132.5674 417.8944)",
  className: "boatst1",
  width: 30.2,
  height: 3.8
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 127.9,
  y: 273.1,
  transform: "matrix(0.6481 -0.7615 0.7615 0.6481 -159.0997 205.6491)",
  className: "boatst1",
  width: 30.2,
  height: 3.8
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  x: 127.9,
  y: 273.4,
  transform: "matrix(-0.6386 -0.7695 0.7695 -0.6386 22.5178 561.0365)",
  className: "boatst1",
  width: 30.2,
  height: 3.8
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  className: "boatst2",
  cx: 142.9,
  cy: 275.1,
  r: 9.9
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  className: "boatst3",
  cx: 142.9,
  cy: 275.1,
  r: 4.3
})), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
  className: "boatst4",
  points: "140.8,256.9 140.8,255.4 144.5,255.4 144.5,257.1 140.8,257.1  "
})), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
  className: "boatst4",
  points: "140.8,294.4 140.8,293 144.5,293 144.5,294.7 140.8,294.7  "
})), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
  className: "boatst4",
  points: "153.2,260.1 154.2,258.9 157.1,261.4 155.9,262.7 153.1,260.3  "
})), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
  className: "boatst4",
  points: "152.9,290.3 153.8,291.5 156.7,289 155.5,287.7 152.7,290.1  "
})), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
  className: "boatst4",
  points: "132.7,259.9 131.8,258.8 128.9,261.2 130,262.5 132.9,260.1  "
})), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
  className: "boatst4",
  points: "132.7,290.3 131.8,291.5 128.9,289 130,287.7 132.9,290.1  "
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  x: 160.8,
  y: 273.4,
  className: "boatst4",
  width: 1.7,
  height: 3.8
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  x: 123.1,
  y: 273.4,
  className: "boatst4",
  width: 1.7,
  height: 3.8
}))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  className: "boatst5",
  d: "M178.5,278.7c0,0-3.5,3.4-6.3-5.1c0,0,6.3-2.6,5.7-7.9c0,0-1.3-13.1-17-15.2c0,0-0.2-1.4-2.5-3.5 c0,0,19.9-0.9,25.3,20.1C183.8,267.2,185.4,273.8,178.5,278.7z"
})), _line || (_line = /*#__PURE__*/React.createElement("line", {
  className: "boatst6",
  x1: 259.5,
  y1: 182.5,
  x2: 229.4,
  y2: 277.4
})), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
  className: "boatst6",
  x1: 131.5,
  y1: 250.2,
  x2: 72.3,
  y2: 157
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGIDBOAT_2_",
  gradientUnits: "userSpaceOnUse",
  x1: 134.2093,
  y1: 273.0682,
  x2: 420.1426,
  y2: 273.0682
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.002702703,
  style: {
    stopColor: "#542C0F"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5622,
  style: {
    stopColor: "#E16726"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6699,
  style: {
    stopColor: "#DA5C26",
    stopOpacity: 0.9751
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8652,
  style: {
    stopColor: "#CA3D28",
    stopOpacity: 0.9299
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9946,
  style: {
    stopColor: "#BF2028",
    stopOpacity: 0.9
  }
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  className: "boatst7",
  d: "M419.2,231.2L354.1,262c0,0-6.1,15-19.7,21.2c0,0-21.9,10.7-23.7,34.1c0,0-57.8,10.1-157.7-13 c-11.7-4.3-16.4-8.5-18.7-33.3v-9l36.8-9.8l3.2,7.6c0,0,33.5,25.4,63.9,16.1c0,0,22.1-7.1,23-12c0,0,64.7-4.8,82.6-14.3l73.1-23.2 C416.9,226.6,422.3,226.1,419.2,231.2z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  className: "boatst8",
  d: "M418.8,230.1l-66.3,30c0,0-7.4,16.4-20.7,22.4c0,0-24.6,10.3-26.4,32.8c0,0-53.4,9.6-151.1-12.5 c-11.4-4.1-16-8.2-18.3-31.9v-7.2l23.7-5l11.9,2.3c0,0,36.4,27.1,66.1,18.2c0,0,24.5-8.3,25.4-13c0,0,64.6-6.6,77.9-12.9l76.2-25.5 C417.2,227.6,420.2,227.1,418.8,230.1z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "boatst9 hair",
  d: "M252.2,234.3c0.8-0.7-0.4-2-0.4-2c0.8-0.8-0.7-1.2-0.7-1.2c-0.5-0.1-1.3,0.3-1.3,0.3l0,0.1 c-0.2,0.5-0.5,0.3-0.5,0.3l0-0.1c0,0-2.8,1.8-2.5,3.1c-2.7,3.1-7.1,5-10.5,9.2c-3.1-0.4-7.1,2.2-9.4,1.6c0,0-2.5-1.4-6-1.8 c-1.1-0.6-2-0.7-2-0.7c9.4-2.7,5.7-9.7,5.7-9.7s0.2-18.1-23.8-10.1c0,0-2,1.3-3.5,0.1c0,0,0.6,1.1,1.4,1.5c-2-0.1-5.9,0-6.9,2 c0,0-1.4,1.2-2.1,1.2c0,0,1.7,0.1,3.5-0.1c-2.2,0.6-5.9,1.9-8.1,3.9c0,0,4.1-2,5.6-0.7c0,0-6.8-0.4-7.2,4.4c0,0,1.1-1.9,3.2-1.9 c0,0,5.9,2,7.6,0c0,0-1.3,1.6-2.7,1.6c0,0,8.8,0.7,8.4-4.1c0,0,1.2,3.9-0.8,3.7c0,0,1.2,0.1,2.2-0.3c-0.2,0.9-0.3,1.6,0,1.6 c0,0,0.8-1.6,2.2-1.2c0,0-1.2,3-2,3.2c0.4,0,1.2,0.1,1.9-0.1c-1,0.7-2.4,1.7-3.3,1.6c0.7,0.2,2,0.5,3.3,0.6 c-0.4,0.3-0.6,0.7-0.7,1.2c0,0,1.3-0.6,1.9,0c0,0,1.5-0.6,1.4,1c0,0-6.3,2.2-7.8,8.4c0,0-1.6,5.2-5.1,6.1c0,0,1.1,0.5,2.4-0.1 c-1.5,1.2-3.9,3.3-3.3,4.8c0,0,1.6-3,3.2-2.6c0,0-2.8,3.5-4.6,3c0,0,2.3,1,3.7,0.8c-0.6,0.4-1.3,1-1.3,1.8c0,0,2.4-0.1,2.7,0.9 c0,0-1.1,1.7-2.1,1.7c0,0,1.7,0.8,2.7,0.5c-1.1,0.7-3.5,2-4.5,1.5c0,0,4,1.9,5,0.4c0,0,0.4,0.6,1.9,1.6c0,0,0,0,0,0 c-0.5,1.6,0,2,0,2c11.5,4.6,22.4,4.8,22.4,4.8s1.7,0.3,2.5,1.2c0,0,0.2,1.1-0.5,1.5c0,0,0.8,1.7,1.9-0.1c0,0,0.3,1.8,1.5,0 c0,0,0.8,1,1.5-0.3c0,0,0.4,0.7,1-0.5c0,0,0.4-1.1-0.3-2.5c0,0-0.5-0.8-1.6-0.6c-1.1,0.2,0.4-2.3,0.4-2.3 c1.8-3.8,0.4-10.9-1.4-15.8c0,0,0,0,0.1,0.1c0,0-0.7,5.1,2,4.1c0,0-1.1-0.6,2.3-7.3c0,0-2.2,3.7-0.1,5c0,0-0.8-4.5,3.9-7.3 c0,0,0,1.3,1,2c0,0,0.5-4.8,4.7-7c0,0-0.3-0.2,0.5,0.4c0,0,2.6-4.9,4.4-6.4c0,0,0.4,0.3,0.8,1.5c0,0,0.5-2.9,2-5 c1.6-0.1,3-0.9,3-0.9c0.9-0.6,0.7-2.1,0.7-2.1C253,235.5,252.2,234.3,252.2,234.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "boatst10",
  d: "M200.5,239.6c-0.3-0.1-0.4-0.1-0.4-0.1C200.1,239.6,200.3,239.6,200.5,239.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "boatst10",
  d: "M201.8,238.1c-0.1,0-0.2,0-0.2,0C201.6,238.1,201.7,238.1,201.8,238.1z"
}))), /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGIDBOAT_3_",
  gradientUnits: "userSpaceOnUse",
  x1: 320.8843,
  y1: 172.9642,
  x2: 223.2264,
  y2: 342.1127
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.002702703,
  style: {
    stopColor: "#542C0F"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5622,
  style: {
    stopColor: "#E16726",
    stopOpacity: 0.4
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6712,
  style: {
    stopColor: "#DA5C26",
    stopOpacity: 0.3004
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8689,
  style: {
    stopColor: "#CA3D28",
    stopOpacity: 0.1197
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#BF2028",
    stopOpacity: 0
  }
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  className: "boatst11",
  d: "M417.5,229.8l-66.6,28.8c0,0,0,11.7-20.7,23.7c0,0-24.2,10-26,31.9c0,0-52.6,9.4-148.8-12.2 c-11.3-4-15.8-7.9-18-31l1.1-6.2l19.5-3.5l12.7,1.2c0,0,37.1,29.6,66.4,21c0,0,26.2-10.3,27.9-14c0,0,51.8-6.7,64.8-10.4l86.9-30.4 C416.8,228.6,418.3,228.5,417.5,229.8z"
})), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  className: "boatst12",
  cx: 219,
  cy: 91.7,
  rx: 216.9,
  ry: 90
})), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
  className: "boatst13",
  points: "158.9,46.3 268.1,45.2 270.9,93.8 156.6,93.8 "
})), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
  className: "boatst14",
  points: "348.5,54.7 268.1,45.2 270.9,93.8 351.9,92.1 "
})), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
  className: "boatst15",
  points: "418.3,64.5 424.5,86.6 351.9,92.1 348.5,54.7 "
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  className: "boatst16",
  d: "M429.8,67c0,0,9.1,5.3,6.4,18.8l-11.8,0.8l-6.2-22.1L429.8,67z"
})), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
  className: "boatst14",
  points: "86.9,54.7 158.9,46.3 156.6,93.8 82.4,91.5 "
})), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
  className: "boatst15",
  points: "22.4,64.2 86.9,54.7 82.4,91.5 15.9,86.6 "
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  className: "boatst16",
  d: "M1.5,85.5c0,0-2-11.6,5.9-18.9l15-2.4l-6.5,22.4L1.5,85.5z"
})), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
  className: "boatst14",
  points: "163.4,17.6 262.9,16.5 268.1,45.2 158.9,46.3 "
})), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
  className: "boatst17",
  points: "94,29.9 163.4,17.6 158.9,46.3 86.9,54.7 "
})), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
  className: "boatst18",
  points: "22.4,64.2 33.5,48.8 94,29.9 86.9,54.7 "
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  className: "boatst19",
  d: "M7.4,66.5c0,0,4.9-11.5,13.9-14.2l12.3-3.5L22.4,64.2L7.4,66.5z"
})), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
  className: "boatst17",
  points: "340.6,29.6 262.9,16.5 268.1,45.2 348.5,54.7 "
})), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
  className: "boatst18",
  points: "409.1,51 340.6,29.6 348.5,54.7 418.3,64.5 "
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  className: "boatst19",
  d: "M429.8,67c0,0,0.3-6.5-10-12.4L409.1,51l9.2,13.5L429.8,67z"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  className: "boatst15",
  d: "M166.8,3.3c0,0,57.7-6.6,92.7-1.1l3.4,14.3l-99.5,1.1L166.8,3.3z"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  className: "boatst20",
  d: "M94,29.9l69.4-12.3l3.4-14.3c0,0-55,9-65.1,12.3L94,29.9z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  className: "boatst21",
  d: "M33.5,48.8L43.3,37c0,0,33.1-16.8,58.5-21.4L94,29.9L33.5,48.8z"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  className: "boatst22",
  d: "M21.3,52.3c0,0,1.5-4.3,13.5-11.1l8.5-4.3l-9.7,11.8L21.3,52.3z"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  className: "boatst20",
  d: "M329.7,12.8c0,0-59-11.3-70.1-10.7l3.4,14.3l77.7,13L329.7,12.8z"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  className: "boatst21",
  d: "M409.1,51L396,37c0,0-51.9-23.9-66.3-24.1l10.9,16.7L409.1,51z"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  className: "boatst22",
  d: "M419.8,54.7c0,0-0.1-7.4-23.9-17.7l13.1,14L419.8,54.7z"
})), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
  className: "boatst14",
  points: "156.6,93.8 270.9,93.8 267.5,137.4 162.7,137.4 "
})), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
  className: "boatst17",
  points: "82.4,91.5 156.6,93.8 162.7,137.4 86.9,127.9 "
})), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
  className: "boatst18",
  points: "15.9,86.6 82.4,91.5 86.9,127.9 20.8,113.8 "
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  className: "boatst19",
  d: "M5.9,110.4c0,0-9.4-9.6-4.4-24.9l14.4,1.1l5,27.3L5.9,110.4z"
})), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
  className: "boatst17",
  points: "351.9,92.1 270.9,93.8 267.5,137.4 347.1,126.8 "
})), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
  className: "boatst18",
  points: "424.5,86.6 351.9,92.1 347.1,126.8 419.8,109.9 "
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  className: "boatst19",
  d: "M436.2,85.8l-11.8,0.8l-4.7,23.3l14.6-3.4C434.3,106.5,441.1,97.9,436.2,85.8z"
})), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
  className: "boatst15",
  points: "168.9,167.9 261.2,168.5 267.5,137.4 162.7,137.4 "
})), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
  className: "boatst20",
  points: "96.2,159.5 86.9,127.9 162.7,137.4 168.9,167.9 "
})), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
  className: "boatst21",
  points: "20.8,113.8 86.9,127.9 96.2,159.5 30.1,133.6 "
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  className: "boatst22",
  d: "M5.9,110.4l15,3.5l9.3,19.8l-7.1-2.2C23,131.4,7.4,122.2,5.9,110.4z"
})), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
  className: "boatst20",
  points: "267.5,137.4 347.1,126.8 338.1,158.8 261.2,168.5 "
})), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
  className: "boatst21",
  points: "419.8,109.9 347.1,126.8 338.1,158.8 408.8,132.5 "
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  className: "boatst22",
  d: "M434.3,106.5l-14.6,3.4l-11,22.6l9.5-4.6C418.3,127.9,435.7,116.8,434.3,106.5z"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  className: "boatst20",
  d: "M173.9,182.8l-5-14.9l92.4,0.6l-7.1,13.9C254.2,182.5,214.5,184.4,173.9,182.8z"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  className: "boatst23",
  d: "M338.1,158.8l-76.9,9.8l-7.1,13.9c0,0,63.6-3.8,74.4-11.7L338.1,158.8z"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  className: "boatst24",
  d: "M408.8,132.5l-70.6,26.3l-9.6,12c0,0,50.3-14.1,68.6-26.7L408.8,132.5z"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  className: "boatst25",
  d: "M418.3,127.9c0,0-7.7,11.7-21.2,16.2l11.7-11.6L418.3,127.9z"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  className: "boatst23",
  d: "M96.2,159.5l72.7,8.4l5,14.9c0,0-54.5-6-71-13.7L96.2,159.5z"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  className: "boatst24",
  d: "M30.1,133.6l66.1,25.9l6.7,9.6c0,0-48.3-13.4-62-24.9L30.1,133.6z"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  className: "boatst25",
  d: "M23,131.4c0,0,8.6,8.8,17.9,12.8l-10.8-10.5L23,131.4z"
})), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
  className: "boatst26",
  x1: 107.3,
  y1: 171.3,
  x2: 142.7,
  y2: 252.5
})), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
  className: "boatst6",
  x1: 180.6,
  y1: 182.8,
  x2: 160.3,
  y2: 247.9
})), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
  className: "boatst27",
  x1: 248.5,
  y1: 183.4,
  x2: 250.7,
  y2: 271.4
})), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
  className: "boatst27",
  x1: 305.8,
  y1: 177.1,
  x2: 307.9,
  y2: 258.8
})), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
  className: "boatst6",
  x1: 363.8,
  y1: 161,
  x2: 408.5,
  y2: 229.3
})), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
  className: "boatst28",
  points: "21.7,51.5 93.5,29.8 163.8,17.2 262.3,16.1 339.3,29.2 419.8,54.7  "
}), /*#__PURE__*/React.createElement("polyline", {
  className: "boatst28",
  points: "7.4,66.5 88,54.5 159.3,46.1 267.5,45 347.1,54.5 429.8,67  "
}), /*#__PURE__*/React.createElement("polyline", {
  className: "boatst28",
  points: "23,131.4 96.2,159.5 172.8,168.5 261.2,168.5 338.1,158.8 418.3,127.9  "
}), /*#__PURE__*/React.createElement("polyline", {
  className: "boatst28",
  points: "5.9,110.4 86.9,127.9 162.7,137.4 267.5,137.4 347.1,126.8 434.3,106.5  "
}), /*#__PURE__*/React.createElement("polyline", {
  className: "boatst28",
  points: "1.5,85.5 84.7,91.5 157.1,93.8 270.2,93.8 349.4,92.1 436.2,85.8  "
}), /*#__PURE__*/React.createElement("polyline", {
  className: "boatst28",
  points: "102.7,15.2 95.1,29.6 86.9,54.7 82.4,91.5 86.9,127.9 96.2,159.5 102.9,169.1  "
}), /*#__PURE__*/React.createElement("polyline", {
  className: "boatst28",
  points: "167.1,2.8 163.8,17.2 159.3,46.1 157.1,93.8 162.7,137.4 168.9,167.9 173.9,182.8  "
}), /*#__PURE__*/React.createElement("polyline", {
  className: "boatst28",
  points: "259,1.7 262.3,16.1 267.5,45 270.2,93.8 267.5,137.4 261.2,168.5 254.2,182.5  "
}), /*#__PURE__*/React.createElement("polyline", {
  className: "boatst28",
  points: "328.4,12.4 340.6,29.6 348.5,54.7 351.9,92.1 347.1,126.8 338.1,158.8 328.5,170.8  "
}), /*#__PURE__*/React.createElement("polyline", {
  className: "boatst28",
  points: "44.8,36.7 34.1,48.1 22.4,64.2 15.9,86.6 20.8,113.8 30.1,133.6 40,143.3  "
}), /*#__PURE__*/React.createElement("polyline", {
  className: "boatst28",
  points: "396.6,37.7 408.6,50.9 418.5,65.3 424.5,86.6 419.8,109.9 408.8,132.5 397.5,143.6  "
}))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  className: "boatst10",
  d: "M214.4,245.7"
})), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
  className: "boatst28",
  x1: 162.7,
  y1: 137.4,
  x2: 157.1,
  y2: 248.7
})), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  className: "boatst29",
  d: "M219.5,232.4c0,0-0.4-2-1.8-2.9c0,0-2.6-0.9-3.7,3.1C214,232.5,217.4,232.1,219.5,232.4z"
})), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
  className: "boatst30",
  d: "M224.2,236.9c0,0,1.3-2.4,1.1-4c0,0-1.3-0.7-2.7-0.4l0.2,3.9L224.2,236.9z"
})), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
  className: "boatst31",
  d: "M220.4,234.3c0,0,2.5,0,2.6,0.1"
})), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
  className: "boatst32",
  d: "M203.4,222.4c0,0,8.1,2.1,5.1,7.6c0,0-1.1,2.3-4.6,4.8v1l10.2-3.4l6.3,2l0.4-2.1l1.9,0.1l2.1,0.9 c0,0,0.4-1.7-0.4-2.4c0,0-0.7-6.5-7.2-8.9C217.1,222,212.2,219.4,203.4,222.4z"
})), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
  className: "boatst33",
  d: "M210.1,224.6c0,0,5.2,1.4,3.3,5.2c0,0-0.7,1.6-3,3.3v0.7l4.6-0.3l6.1-0.7l0.3-1.4l1.2,0l0.4,1.6 c0,0,1.3-2.1,0.7-2.6c0,0-0.4-4.5-4.7-6.1C219,224.3,215.8,222.5,210.1,224.6z"
})), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
  className: "boatst30",
  d: "M220.6,236.6c0,0,0.2-2.9,0.1-4.2c0,0-4.1-0.5-9.4,0.7c0,0,0.9,4,4.2,4.8C215.6,237.9,218.4,238.9,220.6,236.6 z"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  className: "boatst34",
  cx: 217.9,
  cy: 234.5,
  r: 2.6
})), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
  className: "boatst35",
  cx: 218.1,
  cy: 234.5,
  rx: 2.3,
  ry: 2.4
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  className: "boatst36",
  cx: 218.7,
  cy: 234.5,
  r: 0.6
})), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
  className: "boatst34",
  cx: 224.3,
  cy: 234.3,
  rx: 1.4,
  ry: 2.2
})), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
  className: "boatst35",
  cx: 224.4,
  cy: 234.3,
  rx: 1.3,
  ry: 2.1
})), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
  className: "boatst36",
  cx: 224.8,
  cy: 234.2,
  rx: 0.3,
  ry: 0.4
})), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
  className: "boatst5",
  d: "M136.1,280.8c0,0,99.7,51.9,179.5,13.1c-9.8,12.2-9.6,22.4-9.6,22.4s-58.7,11.5-153.3-12.7 c0,0-12.6-5.1-15.3-16.1L136.1,280.8z"
})), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
  className: "boatst5",
  d: "M255,308.4c0,0-33.8-4.7-30.3-22.1c0,0-71.7-1.6-83.4-12.5c0,0-4.4,4-2.8,11.9C138.5,285.7,171,313.8,255,308.4 z"
})), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
  className: "boatst37",
  d: "M227.8,276.9c0,0-0.2,0-0.5-0.1c-1.7-0.4-7.3-1.7-8.6-2.9c0,0-2.9-3.5-7.4-4.8c0,0-0.1-2-3.3-9.7 c0,0,1.8-9-0.6-13.4c0,0-1.4-2.2-2.7-2.7l1.6-0.7c0,0,1.9,1.6,1.8,3.3c0,0,0.6-1.6,1.3-1.4c0,0-1.3,1.8,0,4.4c0,0,0.6-3,1.5-3.4 c0,0,0.6,3.7-0.8,4.5c0,0,2.7-0.4,3.1-3.8c0,0,0.1,2.4-0.9,3c0,0,3,0.1,3.1-3c0,0-0.3,1.5-0.5,3.3c0,0,1.2-1.3,2.2-4.3 c0,0-0.8,2-0.8,3.8c0,0,1.2-3,1.7-3.6c0,0,0.1,1.6,0.8,2.9c0,0,0.1,0,0-2c0,0,0.1-1.2,0.6-1.1c0,0,1,1.8,0.2,2.7 c0,0,0.4,0.4,0.9-2.1c0,0,5.9,2.6,6.1,13.5c0,0,1.4,3.8,1.8,6C228.4,264.9,229.7,269.4,227.8,276.9z"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGIDBOAT_4_",
  gradientUnits: "userSpaceOnUse",
  x1: 197.5008,
  y1: 275.0892,
  x2: 197.5008,
  y2: 309.999
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#FDB829"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1371,
  style: {
    stopColor: "#E6A52B"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3867,
  style: {
    stopColor: "#BB8129"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7179,
  style: {
    stopColor: "#81511E"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#542C0F"
  }
})), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
  className: "boatst38",
  d: "M255.6,308.9c0,0-55.8,2.1-31.9-21.1c0,0-70.2-2.3-81.7-12.7c0,0-7.2,9,2.1,18.4 C144.1,293.5,175.1,315,255.6,308.9z"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGIDBOAT_5_",
  gradientUnits: "userSpaceOnUse",
  x1: 148.0457,
  y1: 244.5185,
  x2: 152.9107,
  y2: 258.6475
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#FDB829"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1059,
  style: {
    stopColor: "#E6A82E"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2988,
  style: {
    stopColor: "#BC8831"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.557,
  style: {
    stopColor: "#825B2C"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8672,
  style: {
    stopColor: "#432B1B"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#2A140B"
  }
})), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
  className: "boatst39",
  d: "M170.1,252.7c0,0,5.9-7.2-3.4-11.8l-35.2,9.3c0,0-6.7,8.2,2.7,12L170.1,252.7z"
})), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
  className: "boatst10",
  d: "M228,276.5c0,0-1.5-1.1-5-0.7l-4.9-1.9c0,0-4.7-4.5-7.8-4.8c0,0-1.6-10.2-4.3-14.8c0,0,3.3-7-2.8-11.1 c0,0-6.5-1.7-7.9,8.7c0,0-0.6,3.1-2.7,3.2c0,0,2.8,0.5,2.9-0.9c0,0-0.6,3.3-2.1,3.8c0,0,2.9-0.5,2.9-2.8 M196.3,255.1 c0,0,1.8,4.9-1.8,6.2h2.3l-2.3,2c0,0,2.4-0.3,2.3,1.2c0,0,0.6,1.5-1.2,2.5c0,0,1,0.7,2.5,0c0,0-0.9,2.2-1.8,2.5c0,0,0.8,0.8,2.1,0 c0,0,0.5,3.2-1,3.9l2.5-0.3v1.1c0,0,13.4,4.1,23.8,4c0,0,0.1-0.7,0.5-0.9c0,0,0.6-0.1,1.1,0.3c0,0,0.1-1.3,1.4-0.1 c0,0,0.4-1.3,1.4-0.1c0,0,0-1.2,1.3,0.1c0,0-0.3-0.9-1.4-0.9"
})), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
  className: "boatst40",
  d: "M219.5,254.2c0,0-6.9-1.5-9.4-4.4c0,0,2.3,8.9,0.7,10.4c0,0,5.7,9.1,13.9,5l2.4-3.9c0,0-0.2-10.7-3.1-12.4 C224,248.9,224.2,254.9,219.5,254.2z"
})), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
  className: "boatst10",
  d: "M201.5,223.8l-1.3,0.4l1.4,0.1l-1.8,0.3c0,0,1.3,0.2,1.9,0.3c0,0-1.2,0-1.8,0.1l0.5,0.2c0,0-3,0.1-5.1,1.8 c0,0,0-0.4,1.3-0.3c0,0-1.6,1.1-2.5,1.2c0,0,1.1,0.4,2,0c0,0-3.9,0.7-5.3,2.4c0,0,2.8-1.5,3.8-1c0,0-1,2.8-5.1,3.6 c0,0,5-0.4,6.9-2.2c0,0-0.1,1.5-1,1.7c0,0,3.1-0.6,3.4-1.7c0,0,1,0.9,0.1,1.4c0,0,2.8-0.5,3.1-1.7c0,0-0.7,1.1-0.4,1.8 c0,0,3.5-2.2,2.7-3.5c0,0,0.6,1.9-0.6,2.4c0,0,0.7,0.4,1.8-1.1c0,0,2.3-2.7,2.2-3.7c0,0,0.3-1.6-2.8-2.2L201.5,223.8z"
})), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
  className: "boatst9",
  d: "M224.4,242.7c0,0-0.8,5.5-4.1,7.4c0,0,1.5-1.5,1.6-3.6c0,0-2.3,2.7-2.7,4.5c0,0,0.3-3.6,1.1-4.1 c0,0-1.8,4-3.5,5c0,0-0.1-1.7,1.3-4c0,0-1.4,1.4-1.8,3.1c0,0-0.1-1.7,0.7-3.1c0,0-1.1,2.2-3.4,2.5c0,0,1.9-1.1,2.1-3 c0,0-1.3,0.8-1.3,1.6c0,0-0.5-1.4,0.3-2.1c0,0-2.3,0.2-1.9,1.4c0,0-0.6-0.3,0-2.6c0,0,0.8-2.6,2.9-5c0,0,1.1-1.3,2.7-1.6l0.4-0.9 c0,0-2.9,0.6-4.6-0.6c0,0-3-1.8-2.9-3.1l1.5-0.1c0,0,0.8,4.1,6,3.4l0.2,0.6C219.2,238.4,216.7,242.8,224.4,242.7z"
})), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
  className: "boatst3",
  d: "M221.8,251.9c0,0-6.3,7.8,4,13.3C225.8,265.2,229.7,255.6,221.8,251.9z"
})), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
  className: "boatst41",
  d: "M224.4,242.1c0,0-0.7,5-3.6,6.8c0,0,1.3-1.3,1.4-3.3c0,0-2,2.5-2.4,4.1c0,0,0.3-3.4,1-3.8c0,0-1.6,3.7-3.1,4.6 c0,0-0.1-1.6,1.1-3.7c0,0-1.2,1.3-1.5,2.9c0,0-0.1-1.6,0.6-2.9c0,0-1,2-3,2.3c0,0,1.7-1.1,1.8-2.8c0,0-1.1,0.7-1.2,1.5 c0,0-0.4-1.3,0.3-2c0,0-2,0.2-1.7,1.3c0,0-0.6-0.2,0-2.4c0,0,0.7-2.4,2.5-4.6c0,0,1-1.2,2.4-1.5l0.4-0.8c0,0-3,1.4-4.6,0.3 c0,0-3.6-1.5-3.6-3.6l2.9-0.1c0,0,0.7,3.9,5.3,3.2l0.2,0.6C219.8,238.1,217.6,242.2,224.4,242.1z"
})), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
  className: "boatst30",
  d: "M221,236.1c0,0,4.1-0.8,5.6,2.8c1.5,3.6-3.4,4.8-3.4,4.8s-6.2,0.7-5.9-2.4C217.3,241.3,217.2,236.7,221,236.1z "
})), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
  className: "boatst42",
  d: "M222.4,275.5c0,0-4.8-0.4-8.8,1.6c0,0,1.8-0.3,2.3-0.2c0,0-1.3,0.4-1.4,0.4c0,0,1.6,0.2,2.3,0l-1.1,0.3 c0,0,2.7,0.2,3.7-0.2C219.4,277.4,217.9,275.8,222.4,275.5z"
})), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
  className: "boatst43",
  d: "M225.9,238.1c0,0,3.2-0.2,4.1,4.4c0,0,2.1,9-4.9,16.3c0,0-1.7,0.6-1.2-2.5c0,0,5.5-5.3,4.2-13 c0,0-0.5-2.2-2.1-2C226,241.3,224.6,239.5,225.9,238.1z"
})), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
  className: "boatst32",
  d: "M222.9,275.6c0,0-4,0.1-3.1,1.6l4.1,0.3c0,0,0.2-1.2,1.4,0c0,0,0.2-1.5,1.4-0.1c0,0,0.2-1.4,1.4-0.1 c0,0,0-1.2,1.3,0.1c0,0-0.3-1.6-4.3-1.3C225,276.1,223.3,275.6,222.9,275.6z"
})), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
  className: "boatst33",
  d: "M224,278c0,0,0.5,0.8,0.5,1.6c0,0,0,0.9-0.3,1c0,0,0.7,0.9,1.3-0.2c0,0,0.6-1.3-0.2-2.4 C225.4,278,224.1,276.3,224,278z"
})), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
  className: "boatst33",
  d: "M225.6,277.9c0,0,0-1.7,1.1,0c0,0,0.9,1.6,0.2,2.9c0,0-0.6,0.5-1,0C225.8,280.8,226.5,279.4,225.6,277.9z"
})), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
  className: "boatst33",
  d: "M226.8,277.6c0,0,0.2-1.4,1.2,0c0,0,0.8,1.5,0.4,2.8c0,0-0.5,0.7-1.2,0C227.3,280.4,227.8,279.5,226.8,277.6z"
})), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
  className: "boatst33",
  d: "M228.3,277.6c0,0-0.1-1.2,1.1,0c0,0,0.7,2.1-0.1,2.7c0,0-0.3,0.2-0.5,0C228.7,280.3,229,279,228.3,277.6z"
})), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
  className: "boatst30",
  d: "M206.9,256.2c0,0,1.5-9.1-2.2-13c0,0,6,3.1,3.3,16.2L206.9,256.2z"
})), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
  className: "boatst9",
  d: "M211.4,269.1c0,0-5.9-1.4-6.6,2.1c0,0-0.7,1.5-1.8,1.2c0,0,1.4,0.6,2.3,0c0,0-0.2,0.9-0.6,0.9 c0,0,1.1,0.3,1.5,0l-0.1,0.5c0,0,2.3-0.7,2.9,0c0,0-0.2,0.4-0.4,0.4c0,0,1.7,0.2,2.4,0l0.4,0.8h0.6h0.2c0,0,0.4,0.5,0,0.6 c0,0,3-2.4,6.4-1.8C218.7,273.9,215.4,270.3,211.4,269.1z"
})), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
  className: "boatst28",
  x1: 217.2,
  y1: 278.5,
  x2: 267.5,
  y2: 137.4
})), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
  className: "boatst10",
  d: "M206.9,236c0,0-2.6,0-2.9,1c0,0,1.3-0.1,1.5,0.5c0,0-0.8,1.5-2,2c0,0,0.8,0.7,2.8,0l-1.3,1.9l1.8-0.5 c0,0,1.1,1.7,1.1,2.5l1.4-0.4c0,0,0.8-0.2,0.3,1.2c0,0,0.7,0.3,1.5-0.8c0,0,0.1-3.3,2.6-3.9c0,0-2.8-1.3-3.5-3 C210.1,236.5,208.6,235.8,206.9,236z"
})), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
  className: "boatst30",
  d: "M203.8,235.9c0,0,3.5-2.3,7.7-2.9l0.4,1.4c0,0-2.3,0.4-8.3,2C203,237.4,203.8,235.9,203.8,235.9z"
})), /*#__PURE__*/React.createElement("g", {
  className: "gearsSpinner"
}, /*#__PURE__*/React.createElement("radialGradient", {
  id: "SVGIDBOAT_6_",
  cx: 237.3112,
  cy: 292.5895,
  r: 11.5319,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#C56E29"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6081,
  style: {
    stopColor: "#C56E29"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7886,
  style: {
    stopColor: "#C66F29"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8563,
  style: {
    stopColor: "#CA7528"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9051,
  style: {
    stopColor: "#D17E27"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9447,
  style: {
    stopColor: "#DA8B25"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9784,
  style: {
    stopColor: "#E89D20"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#F7B01A"
  }
})), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
  className: "boatst44",
  d: "M237.3,281.3c-6.2,0-11.3,5.1-11.3,11.3s5.1,11.3,11.3,11.3s11.3-5.1,11.3-11.3S243.5,281.3,237.3,281.3z  M237.3,301.4c-4.9,0-8.8-3.9-8.8-8.8s3.9-8.8,8.8-8.8s8.8,3.9,8.8,8.8S242.2,301.4,237.3,301.4z"
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  x: 228.5,
  y: 291.6,
  className: "boatst1",
  width: 17.4,
  height: 2.2
})), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  x: 228.5,
  y: 291.6,
  transform: "matrix(6.123234e-17 -1 1 6.123234e-17 -55.4776 529.8828)",
  className: "boatst1",
  width: 17.4,
  height: 2.2
})), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
  x: 228.7,
  y: 291.5,
  transform: "matrix(0.6481 -0.7615 0.7615 0.6481 -139.2492 283.71)",
  className: "boatst1",
  width: 17.4,
  height: 2.2
})), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
  x: 228.7,
  y: 291.6,
  transform: "matrix(-0.6386 -0.7695 0.7695 -0.6386 163.7749 662.2714)",
  className: "boatst1",
  width: 17.4,
  height: 2.2
})), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
  className: "boatst2",
  cx: 237.3,
  cy: 292.6,
  r: 5.7
})), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
  className: "boatst3",
  cx: 237.3,
  cy: 292.6,
  r: 2.5
})), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
  className: "boatst4",
  points: "236.1,282.1 236.1,281.2 238.3,281.2 238.3,282.2 236.1,282.2  "
})), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
  className: "boatst4",
  points: "236.1,303.8 236.1,302.9 238.3,302.9 238.3,303.9 236.1,303.9  "
})), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
  className: "boatst4",
  points: "243.3,283.9 243.9,283.3 245.5,284.7 244.9,285.4 243.2,284  "
})), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
  className: "boatst4",
  points: "243.1,301.4 243.6,302 245.3,300.6 244.6,299.9 243,301.3  "
})), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
  className: "boatst4",
  points: "231.5,283.8 230.9,283.2 229.3,284.6 229.9,285.3 231.6,283.9  "
})), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
  className: "boatst4",
  points: "231.5,301.4 230.9,302 229.3,300.6 229.9,299.9 231.6,301.3  "
})), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
  x: 247.7,
  y: 291.6,
  className: "boatst4",
  width: 1,
  height: 2.2
})), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
  x: 225.9,
  y: 291.6,
  className: "boatst4",
  width: 1,
  height: 2.2
}))), /*#__PURE__*/React.createElement("g", {
  className: "gearsSpinnerRight"
}, /*#__PURE__*/React.createElement("radialGradient", {
  id: "SVGIDBOAT_7_",
  cx: 264.0027,
  cy: 298.4364,
  r: 15.6141,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#C56E29"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6081,
  style: {
    stopColor: "#C56E29"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7886,
  style: {
    stopColor: "#C66F29"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8563,
  style: {
    stopColor: "#CA7528"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9051,
  style: {
    stopColor: "#D17E27"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9447,
  style: {
    stopColor: "#DA8B25"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9784,
  style: {
    stopColor: "#E89D20"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#F7B01A"
  }
})), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
  className: "boatst45",
  d: "M264,283.1c-8.5,0-15.4,6.9-15.4,15.4c0,8.5,6.9,15.4,15.4,15.4c8.5,0,15.4-6.9,15.4-15.4 C279.4,290,272.5,283.1,264,283.1z M264,310.4c-6.6,0-12-5.4-12-12c0-6.6,5.4-12,12-12s12,5.4,12,12C276,305,270.6,310.4,264,310.4 z"
})), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
  x: 252,
  y: 297.1,
  className: "boatst1",
  width: 23.7,
  height: 3
})), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
  x: 252,
  y: 297.1,
  transform: "matrix(6.123234e-17 -1 1 6.123234e-17 -34.705 562.4148)",
  className: "boatst1",
  width: 23.7,
  height: 3
})), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
  x: 252.3,
  y: 296.9,
  transform: "matrix(0.6481 -0.7615 0.7615 0.6481 -134.2873 306.11)",
  className: "boatst1",
  width: 23.7,
  height: 3
})), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
  x: 252.3,
  y: 297.1,
  transform: "matrix(-0.6386 -0.7695 0.7695 -0.6386 203.0365 692.4686)",
  className: "boatst1",
  width: 23.7,
  height: 3
})), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
  className: "boatst2",
  cx: 264,
  cy: 298.4,
  r: 7.8
})), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
  className: "boatst3",
  cx: 264,
  cy: 298.4,
  r: 3.4
})), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
  className: "boatst4",
  points: "262.4,284.1 262.4,283 265.3,283 265.3,284.3 262.4,284.3  "
})), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
  className: "boatst4",
  points: "262.4,313.6 262.4,312.5 265.3,312.5 265.3,313.9 262.4,313.9  "
})), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
  className: "boatst4",
  points: "272.2,286.6 272.9,285.8 275.2,287.7 274.3,288.7 272,286.8  "
})), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
  className: "boatst4",
  points: "271.9,310.4 272.6,311.3 274.9,309.4 274,308.4 271.7,310.3  "
})), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
  className: "boatst4",
  points: "256,286.5 255.3,285.6 253,287.5 253.9,288.6 256.2,286.7  "
})), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
  className: "boatst4",
  points: "256,310.4 255.3,311.3 253,309.4 253.9,308.3 256.2,310.3  "
})), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
  x: 278.1,
  y: 297.1,
  className: "boatst4",
  width: 1.4,
  height: 3
})), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
  x: 248.5,
  y: 297.1,
  className: "boatst4",
  width: 1.4,
  height: 3
}))), /*#__PURE__*/React.createElement("g", {
  className: "gearsSpinnerRight"
}, /*#__PURE__*/React.createElement("radialGradient", {
  id: "SVGIDBOAT_8_",
  cx: 299.9438,
  cy: 287.8746,
  r: 11.428,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#C56E29"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6081,
  style: {
    stopColor: "#C56E29"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7886,
  style: {
    stopColor: "#C66F29"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8563,
  style: {
    stopColor: "#CA7528"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9051,
  style: {
    stopColor: "#D17E27"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9447,
  style: {
    stopColor: "#DA8B25"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9784,
  style: {
    stopColor: "#E89D20"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#F7B01A"
  }
})), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
  className: "boatst46",
  d: "M299.9,276.7c-6.2,0-11.2,5-11.2,11.2s5,11.2,11.2,11.2s11.2-5,11.2-11.2S306.1,276.7,299.9,276.7z  M299.9,296.6c-4.8,0-8.7-3.9-8.7-8.7s3.9-8.7,8.7-8.7s8.7,3.9,8.7,8.7S304.8,296.6,299.9,296.6z"
})), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
  x: 291.2,
  y: 286.9,
  className: "boatst1",
  width: 17.3,
  height: 2.1
})), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
  x: 291.2,
  y: 286.9,
  transform: "matrix(6.123234e-17 -1 1 6.123234e-17 11.8718 587.8008)",
  className: "boatst1",
  width: 17.3,
  height: 2.1
})), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
  x: 291.4,
  y: 286.8,
  transform: "matrix(0.6481 -0.7615 0.7615 0.6481 -113.622 329.7462)",
  className: "boatst1",
  width: 17.3,
  height: 2.1
})), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
  x: 291.4,
  y: 286.9,
  transform: "matrix(-0.6386 -0.7695 0.7695 -0.6386 270.0338 702.7407)",
  className: "boatst1",
  width: 17.3,
  height: 2.1
})), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
  className: "boatst2",
  cx: 299.9,
  cy: 287.9,
  r: 5.7
})), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
  className: "boatst3",
  cx: 299.9,
  cy: 287.9,
  r: 2.5
})), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
  className: "boatst4",
  points: "298.8,277.5 298.8,276.6 300.9,276.6 300.9,277.6 298.8,277.6  "
})), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
  className: "boatst4",
  points: "298.8,298.9 298.8,298.1 300.9,298.1 300.9,299.1 298.8,299.1  "
})), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
  className: "boatst4",
  points: "305.9,279.3 306.4,278.6 308.1,280 307.4,280.8 305.8,279.4  "
})), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
  className: "boatst4",
  points: "305.7,296.6 306.2,297.2 307.8,295.9 307.2,295.1 305.6,296.5  "
})), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
  className: "boatst4",
  points: "294.1,279.2 293.6,278.6 292,279.9 292.6,280.7 294.2,279.3  "
})), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
  className: "boatst4",
  points: "294.1,296.6 293.6,297.2 292,295.8 292.6,295.1 294.2,296.5  "
})), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
  x: 310.2,
  y: 286.9,
  className: "boatst4",
  width: 1,
  height: 2.1
})), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
  x: 288.7,
  y: 286.9,
  className: "boatst4",
  width: 1,
  height: 2.1
}))), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
  className: "boatst47",
  d: "M261.8,290.3l36.8-8.6c0,0,5.2-0.9,7.2,4c0,0,1.8,5.4-3.1,7.8l-36.5,13c0,0-7.2,1.9-10.2-5.2 C256.1,301.4,253.2,293.3,261.8,290.3z"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "SVGIDBOAT_9_",
  cx: 145.0229,
  cy: 285.9018,
  r: 3.0144,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#000000"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2518,
  style: {
    stopColor: "#040404"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3907,
  style: {
    stopColor: "#121111"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.502,
  style: {
    stopColor: "#211F1F"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5989,
  style: {
    stopColor: "#302B29"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6863,
  style: {
    stopColor: "#3B322D"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7668,
  style: {
    stopColor: "#43352C"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8422,
  style: {
    stopColor: "#4A3628"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9135,
  style: {
    stopColor: "#4F3420"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.979,
  style: {
    stopColor: "#532E13"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#542C0F"
  }
})), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
  className: "boatst48",
  cx: 145,
  cy: 285.9,
  rx: 2.2,
  ry: 3.7
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "SVGIDBOAT_10_",
  cx: 154.6809,
  cy: 289.313,
  r: 3.8437,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#000000"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2518,
  style: {
    stopColor: "#040404"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3907,
  style: {
    stopColor: "#121111"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.502,
  style: {
    stopColor: "#211F1F"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5989,
  style: {
    stopColor: "#302B29"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6863,
  style: {
    stopColor: "#3B322D"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7668,
  style: {
    stopColor: "#43352C"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8422,
  style: {
    stopColor: "#4A3628"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9135,
  style: {
    stopColor: "#4F3420"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.979,
  style: {
    stopColor: "#532E13"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#542C0F"
  }
})), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
  className: "boatst49",
  d: "M157.9,290c-0.5,2.3-2.3,3.9-4.1,3.6c-1.8-0.4-2.9-2.5-2.4-4.9c0.5-2.3,2.3-3.9,4.1-3.6S158.4,287.6,157.9,290 z"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "SVGIDBOAT_11_",
  cx: 167.6384,
  cy: 292.626,
  r: 4.799,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#000000"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2518,
  style: {
    stopColor: "#040404"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3907,
  style: {
    stopColor: "#121111"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.502,
  style: {
    stopColor: "#211F1F"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5989,
  style: {
    stopColor: "#302B29"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6863,
  style: {
    stopColor: "#3B322D"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7668,
  style: {
    stopColor: "#43352C"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8422,
  style: {
    stopColor: "#4A3628"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9135,
  style: {
    stopColor: "#4F3420"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.979,
  style: {
    stopColor: "#532E13"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#542C0F"
  }
})), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
  className: "boatst50",
  d: "M171.9,293.5c-0.6,2.8-2.9,4.7-5.3,4.2c-2.4-0.5-3.8-3.1-3.3-5.9c0.6-2.8,2.9-4.7,5.3-4.2 C171,288,172.5,290.7,171.9,293.5z"
})), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
  className: "boatst51 steam",
  cx: 150,
  cy: 289,
  r: 1.3
})), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
  className: "boatst51 steam",
  cx: 151.6,
  cy: 292.5,
  r: 1.1
})), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
  className: "boatst51 steam",
  cx: 153.3,
  cy: 289.7,
  r: 0.7
})), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
  className: "boatst51 steam",
  cx: 142,
  cy: 285.7,
  r: 0.8
})), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
  className: "boatst51 steam",
  cx: 143.5,
  cy: 284.7,
  r: 0.7
})), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
  className: "boatst51 steam",
  cx: 144.5,
  cy: 286.7,
  r: 0.3
})), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
  className: "boatst51 steam",
  cx: 141.7,
  cy: 287.8,
  r: 0.5
})), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
  className: "boatst51 steam",
  cx: 163.6,
  cy: 292.6,
  r: 1.1
})), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
  className: "boatst51 steam",
  cx: 166.4,
  cy: 290.7,
  r: 0.7
})), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
  className: "boatst51 steam",
  cx: 167.2,
  cy: 293.4,
  r: 0.4
})), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
  className: "boatst51 steam",
  cx: 160.9,
  cy: 295.3,
  r: 1.6
})), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
  className: "boatst51 steam",
  cx: 146,
  cy: 292.5,
  r: 1.8
})), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
  className: "boatst51 steam",
  cx: 147.7,
  cy: 289.1,
  r: 0.5
})), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
  className: "boatst51 steam",
  cx: 142.6,
  cy: 290.5,
  r: 0.9
})), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
  className: "boatst51 steam",
  cx: 140.8,
  cy: 288.8,
  r: 0.3
})), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -163.8148 180.5413)",
  className: "boatst51 steam",
  cx: 136,
  cy: 288,
  rx: 2.1,
  ry: 2.1
})), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
  className: "boatst51 steam",
  cx: 138.7,
  cy: 284.1,
  r: 1.3
})), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
  className: "boatst51 steam",
  cx: 132.4,
  cy: 282.8,
  r: 0.6
})), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
  className: "boatst51 steam",
  cx: 124.8,
  cy: 285.2,
  r: 0.5
})), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
  className: "boatst51 steam",
  cx: 129.1,
  cy: 285.5,
  r: 1.8
})), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
  className: "boatst51 steam",
  cx: 134.2,
  cy: 293.2,
  r: 1.9
})), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
  className: "boatst51 steam",
  cx: 138.8,
  cy: 292.4,
  r: 0.6
})), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
  className: "boatst51 steam",
  cx: 138.4,
  cy: 289.3,
  r: 0.8
})), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
  className: "boatst51 steam",
  cx: 130.7,
  cy: 289.2,
  r: 0.7
})), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
  className: "boatst51 steam",
  cx: 144.3,
  cy: 293.6,
  r: 1.2
})), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
  className: "boatst51 steam",
  cx: 157.3,
  cy: 295.8,
  r: 1.5
})), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
  className: "boatst51 steam",
  cx: 159.6,
  cy: 293.8,
  r: 0.6
})), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
  className: "boatst51 steam",
  cx: 156.2,
  cy: 294.7,
  r: 0.4
})), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
  className: "boatst51 steam",
  cx: 152.6,
  cy: 295.8,
  r: 0.5
})), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
  className: "boatst51 steam",
  cx: 149.7,
  cy: 294.7,
  r: 0.8
})), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
  className: "boatst51 steam",
  cx: 132.2,
  cy: 293.2,
  r: 0.8
})), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
  className: "boatst51 steam",
  cx: 129.9,
  cy: 292.1,
  r: 0.2
})), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
  className: "boatst51 steam",
  cx: 131.1,
  cy: 289.8,
  r: 0.3
})), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
  className: "boatst51 steam",
  cx: 128.3,
  cy: 290.8,
  r: 0.5
})), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
  className: "boatst51 steam",
  cx: 127.5,
  cy: 291.9,
  r: 0.3
})), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -169.8853 171.9854)",
  className: "boatst51 steam",
  cx: 122.7,
  cy: 291.1,
  rx: 2.1,
  ry: 2.1
})), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
  className: "boatst51 steam",
  cx: 111.5,
  cy: 288.2,
  r: 0.5
})), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
  className: "boatst51 steam",
  cx: 115.7,
  cy: 288.6,
  r: 1.8
})), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
  className: "boatst51 steam",
  cx: 117.3,
  cy: 292.3,
  r: 0.7
})), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
  className: "boatst51 steam",
  cx: 116.5,
  cy: 295.1,
  r: 0.2
})), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
  className: "boatst9",
  d: "M211.4,269.1c0,0-2.1-1.6-8.4,0c0,0-1.5,0.5-2.2,1.3c0,0,0.1-2.5,1-2.6c0,0-1.9,0.5-2.2,1.1s-0.3,0.5-0.3,0.5 S205.7,250.6,211.4,269.1z"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgJourneyBoat, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/JourneyBoat.50cd1c19.svg";
export { ForwardRef as ReactComponent };